import React from 'react';
import { ProductPageTiles } from './view/productPageTiles';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'ProductPageTiles', 
  itemElt: (item, cmsOption) => <ProductPageTiles item={item} cmsOption={cmsOption} />
}